import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're0009',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
